import { buildDic } from './buildDic'

export const USER_ACCESS_LEVELS = [
  { key: 'DEFAULT', label: 'Usuário padrão', description: 'Usuário padrão', value: 0 },
  { key: 'CHIEF', label: 'Chefe', description: 'Pode editar grupos/tropas e pessoas.', value: 350 },
  { key: 'FINANCIAL_ADMIN', label: 'Administrador financeiro', description: 'Administrador financeiro do grupo', value: 400 },
  { key: 'GROUP_ADMIN', label: 'Administrador de grupo', description: 'Administrador do grupo', value: 500 },
  { key: 'ADMIN', label: 'Admin', description: 'Administrador', value: 777 },
  { key: 'SUPER_ADMIN', label: 'Super Admin', description: 'Administrador de sistema', value: 778 },
]
export const USER_ACCESS_LEVELS_DIC = buildDic(USER_ACCESS_LEVELS)

export const USER_STATUSES = [
  { label: 'Inativo', description: 'Usuário desativado, não pode fazer login', value: 0 },
  { label: 'Ativo', description: 'Pode acessar o sistema normalmente', value: 1 },
]
export const USER_STATUSES_DIC = buildDic(USER_STATUSES)

export const G_ROLES = [
  { label: 'Padrão', description: 'usuário padrão', value: 0 },
  { label: 'Administrador financeiro', description: 'administrador financeiro do Grupo', value: 4 },
  { label: 'Gestor', description: 'Gestor do grupo', value: 5 },
  { label: 'Administrador do grupo', description: 'administrador do Grupo', value: 7 },
]
export const G_ROLE_DIC = buildDic(G_ROLES)

export const SG_ROLES = [
  { label: 'Padrão', description: 'usuário padrão', value: 0 },
  { label: 'Administrador de grupo/tropa', description: 'administrador do grupo/tropa', value: 7 },
]
export const SG_ROLE_DIC = buildDic(SG_ROLES)

export const LEGAL_PEOPLE_TYPES = [
  { key: 'PADRAO', label: 'Padrão', description: 'pessoa do tipo padrão', value: 0 },
  { key: 'FORNECEDOR', label: 'Fornecedor', description: 'fornecedor', value: 1 },
  { key: 'GRUPO', label: 'Cadastro de grupo', description: 'cadastro de grupo', value: 13 },
]
export const LEGAL_PEOPLE_TYPES_DIC = buildDic(LEGAL_PEOPLE_TYPES, { keyAsValue: true })

export const SPECIAL_FILTERS_LEGAL_PERSON = [
  { label: 'Pessoas sem Grupo/Tropa', value: 'no-sub-group' },
  { label: 'Pessoas sem usuário', value: 'no-user' },
  { label: 'Inadimplentes (com lançamentos vencidas e pendentes)', value: 'defaulters' },
]
export const SPECIAL_FILTERS_NEW_INVOICE = [
  { label: 'Todos do grupo', value: 'all-form-group' },
]
export const SPECIAL_FILTERS_NEW_INVOICE_INTERVALS = [
  { label: 'Mensal (repete o dia do mês)', value: 'monthly' },
  { label: 'Semanal (repete o dia da semana)', value: 'weekly' },
  { label: 'A cada duas semanas (repete o dia da semana)', value: 'every-two-weeks' },
  { label: 'A cada três semanas (repete o dia da semana)', value: 'triweekly' },
  { label: 'Bimestral (repete o dia do mês)', value: 'bimonthly' },
  { label: 'Trimestral (repete o dia do mês)', value: 'quarterly' },
  { label: 'Semestral (repete o dia do mês)', value: 'semester' },
  { label: 'Anual (repete o dia do mês)', value: 'yearly' },
]

export const FILE_TYPE = {
  profile_picture: 0,
  legal_person_picture: 1,
  medical_record: 7,
  group_image: 10,
  sub_group_image: 12,
  event_file: 20,
}

export const CASH_FLOW_CATEGORY_TYPES = [
  { key: 'IN', label: 'ENTRADA', value: 1 },
  { key: 'OUT', label: 'SAÍDA', value: 2 },
  { key: 'BOTH', label: 'ENTRADA & SAÍDA', value: 3 },
]
export const CASH_FLOW_CATEGORY_TYPES_DIC = buildDic(CASH_FLOW_CATEGORY_TYPES)

export const CASHIER_MOVEMENT_TYPES = [
  { key: 'RECIPE', label: 'Recibo', value: 1 },
  { key: 'TRANSFER', label: 'Transferência', value: 2 },
  { key: 'FUTURE', label: 'Futuro', value: 3 },
]
export const CASHIER_MOVEMENT_TYPES_DIC = buildDic(CASHIER_MOVEMENT_TYPES)

export const PAYMENT_METHOD_TYPES = [
  { key: 'CASH', label: 'Dinheiro', value: 0 },
  { key: 'CHECK', label: 'Cheque', value: 1 },
  { key: 'PIX', label: 'PIX', value: 2 },
  { key: 'CREDIT_CARD', label: 'Cartão de crédito', value: 3 },
  { key: 'BANK_TRANSFER', label: 'Transferência bancária', value: 4 },
  { key: 'PAYROLL_DEDUCTION', label: 'Consignado', value: 5 },
  { key: 'DEBIT_CARD', label: 'Cartão de débito', value: 6 },
  { key: 'OTHER', label: 'Outros', value: 7 },
]
export const PAYMENT_METHOD_TYPES_DIC = buildDic(PAYMENT_METHOD_TYPES)

export const EVENT_STATUSES = [
  { key: 'OPEN', label: 'Aberto', color: 'green', value: 0 },
  { key: 'CLOSED', label: 'Fechado', color: 'red', value: 2 },
]
export const EVENT_STATUS_DIC = buildDic(EVENT_STATUSES)

export const EVENT_AUTHORIZATION_STATUSES = [
  { key: 'UNAUTHORIZED', label: 'Não Autorizado', color: 'gred', value: 0 },
  { key: 'AUTHORIZED', label: 'Autorizado', color: 'green', value: 1 },
]
export const EVENT_AUTHORIZATION_STATUS_DIC = buildDic(EVENT_AUTHORIZATION_STATUSES)

export const INVOICE_STATUSES = [
  { key: 'PENDING', label: 'Pendente', color: 'yellow', value: 0 },
  { key: 'PAID', label: 'Pago', color: 'green', value: 1 },
  { key: 'PARTIALLY_PAID', label: 'Parcialmente pago', color: 'green', value: 2 },
  { key: 'OVERDUE', label: 'Vencida', color: 'red', value: 3 },
  { key: 'CANCELED', label: 'Cancelada', color: 'grey', value: 4 },
  { key: 'IN_DISPUTE', label: 'Pedido de devolução', color: 'orange', value: 5 },
  { key: 'UNDER_REVIEW', label: 'Em Revisão', color: 'blue', value: 6 },
  { key: 'APPROVED', label: 'Aprovado', value: 7 },
  { key: 'SENT', label: 'Enviado', value: 8 },
  { key: 'REFUNDED', label: 'Devolvido', value: 9 },
  { key: 'PROCESSING', label: 'Processando pagamento', value: 10 },
  { key: 'WAITING_DUE_DATE', label: 'Aguardando Vencimento', color: 'purple', value: 11 },
]
export const INVOICE_STATUS_DIC = buildDic(INVOICE_STATUSES)

export const PAYABLE_INVOICE_STATUSES = [
  INVOICE_STATUS_DIC.PENDING.value,
  INVOICE_STATUS_DIC.OVERDUE.value,
]

export const INVOICE_TYPES = [
  { key: 'INVOICE', label: 'R', color: 'green', value: 0 },
  { key: 'BILL', label: 'P', color: 'yellow', value: 1 },
  { key: 'SERVICE', label: 'P', color: 'blue', value: 2 },
]
export const INVOICE_TYPE_DIC = buildDic(INVOICE_TYPES)

export const CHECKOUT_STATUSES = [
  { key: 'PENDING', label: 'Pendente', color: 'yellow', value: 0 },
  { key: 'PAID', label: 'Pago', color: 'green', value: 1 },
  { key: 'PAYING', label: 'Em Pagamento', color: 'orange', value: 2 },
]
export const CHECKOUT_STATUS_DIC = buildDic(CHECKOUT_STATUSES)

export const GROUP_PAYMENT_STATUSES = [
  { key: 'CREATED', label: 'Criado', color: 'yellow', value: 0 },
  { key: 'PAID', label: 'Pago', color: 'green', value: 1 },
  { key: 'ERROR', label: 'Com Erro', color: 'red', value: 2 },
  { key: 'EXPIRED', label: 'Expirado', color: 'orange', value: 3 },
  { key: 'CANCELED', label: 'Cancelada', color: 'grey', value: 4 },
]
export const GROUP_PAYMENT_STATUS_DIC = buildDic(GROUP_PAYMENT_STATUSES)

export const NEWS_STATUSES = [
  { key: 'DRAFT', label: 'Rascunho', value: 0 },
  { key: 'SCHEDULED', label: 'Agendado', value: 1 },
  { key: 'EXECUTING', label: 'Executando', value: 2 },
  { key: 'EXECUTED', label: 'Concluída', value: 3 },
]
export const NEWS_STATUS_DIC = buildDic(NEWS_STATUSES)

/** Default bag for plugin install / legacy default import */
const constants = {
  USER_ACCESS_LEVELS_DIC,
  USER_ACCESS_LEVELS,
  USER_STATUSES_DIC,
  USER_STATUSES,
  G_ROLE_DIC,
  G_ROLES,
  SG_ROLE_DIC,
  SG_ROLES,
  LEGAL_PEOPLE_TYPES_DIC,
  LEGAL_PEOPLE_TYPES,
  SPECIAL_FILTERS_LEGAL_PERSON,
  SPECIAL_FILTERS_NEW_INVOICE,
  SPECIAL_FILTERS_NEW_INVOICE_INTERVALS,
  FILE_TYPE,
  CASH_FLOW_CATEGORY_TYPES,
  CASH_FLOW_CATEGORY_TYPES_DIC,
  CASHIER_MOVEMENT_TYPES,
  CASHIER_MOVEMENT_TYPES_DIC,
  EVENT_STATUSES,
  EVENT_STATUS_DIC,
  EVENT_AUTHORIZATION_STATUSES,
  EVENT_AUTHORIZATION_STATUS_DIC,
  INVOICE_STATUSES,
  INVOICE_STATUS_DIC,
  PAYABLE_INVOICE_STATUSES,
  INVOICE_TYPES,
  INVOICE_TYPE_DIC,
  GROUP_PAYMENT_STATUSES,
  GROUP_PAYMENT_STATUS_DIC,
  CHECKOUT_STATUSES,
  CHECKOUT_STATUS_DIC,
  PAYMENT_METHOD_TYPES,
  PAYMENT_METHOD_TYPES_DIC,
  NEWS_STATUSES,
  NEWS_STATUS_DIC,
}

export default constants
